// extracted by mini-css-extract-plugin
export default {"list":"NotificationPanel_list__+RsvU","item":"NotificationPanel_item__5-lC+"};